import type { ComponentType } from "react";
import type { MailerConfigShowQueryType } from "@/types/graphql/admin.generated";
import { MailerConfigDetails } from "../MailerConfigDetails";

export const MailerConfigShowComponent: ComponentType<{
  editData?: unknown;
  id?: string;
  mailerConfig?: MailerConfigShowQueryType["mailerConfig"];
}> = ({ mailerConfig }) => {
  if (!mailerConfig) return <div>Загрузка...</div>;

  return <MailerConfigDetails mailerConfig={mailerConfig} />;
};
